// LICENSE_CODE ZON
'use strict';

/*jslint node:true, react:true*/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState, useRef } from 'react';
import { url2md5, cdn_url } from 'pub_config';
export var use_scrolled = (should_update_state, opt = {}) => {
  var scrolling_timer = useRef();
  var _useState = useState({
      direction: null,
      y: 0,
      scrolling: false,
      started: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    set_state = _useState2[1];
  useEffect(() => {
    var ticking = false;
    var prev_direction = null;
    var prev_y = 0;
    var y = window.scrollY;
    var count = 0;
    var reset_timeout;
    var apply_scroll = () => {
      ticking = false;
      var direction = y > window.scrollY ? 'up' : 'down';
      y = window.scrollY;
      clearTimeout(reset_timeout);
      if (should_update_state && !should_update_state(direction, y, prev_direction, prev_y) && count == 2) {
        return;
      }
      if (prev_direction != direction || count == 0) count = 1;else count = 2;
      reset_timeout = setTimeout(() => count = 0, 50);
      prev_direction = direction;
      prev_y = y;
      set_state(s => _objectSpread(_objectSpread({}, s), {}, {
        direction,
        y,
        count
      }));
    };
    var reset_scroll = () => count = 0;
    var handle_scroll = () => {
      clearTimeout(scrolling_timer.current);
      scrolling_timer.current = setTimeout(() => {
        set_state(s => _objectSpread(_objectSpread({}, s), {}, {
          scrolling: false
        }));
      }, opt.scroll_delay || 500);
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply_scroll);
      set_state(s => _objectSpread(_objectSpread({}, s), {}, {
        scrolling: true
      }));
    };
    handle_scroll();
    window.addEventListener('click', reset_scroll);
    window.addEventListener('scroll', handle_scroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handle_scroll);
      window.removeEventListener('click', reset_scroll);
    };
  }, []);
  useEffect(() => {
    if (state.started) return;
    if (state.y > 0) set_state(s => _objectSpread(_objectSpread({}, s), {}, {
      started: true
    }));
  }, [state.y, state.started]);
  return state;
};
var icons = {
  'bbc.co.uk': url2md5('/www/hola/pub/img/ic_bbc.svg')
};
var siteicon_url = cdn_url + '/access/siteicon';
export var get_icon = (link, siteicon, ref) => icons[link] || (siteicon ? `${siteicon_url}/${link}/40` + (ref ? `?requester=${ref}` : '') : `https://${link}/favicon.ico`);
export var is_scrolled_down = (elem, offset) => {
  var bounding = elem.getBoundingClientRect();
  var h = window.innerHeight || document.documentElement.clientHeight;
  return bounding.bottom <= h + offset;
};